import { auth } from "@/auth/actions";
import { ActiveProgramBanner } from "@/components/active-program-banner";
import Header from "@/components/header";
import * as Sentry from "@sentry/tanstackstart-react";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app")({
  component: RouteComponent,
  beforeLoad: async () => {
    try {
      const result = await auth();
      const subject = result.body;

      return {
        user: subject.authenticated ? subject.properties : null,
      };
    } catch (e) {
      Sentry.withScope((scope) => {
        scope.setTag("auth_flow", "beforeLoad");
        scope.setTag("auth_error", "true");
        scope.setExtra("authError", e);
        scope.setExtra(
          "authErrorMessage",
          e instanceof Error ? e.message : String(e),
        );
        scope.setExtra(
          "authErrorStack",
          e instanceof Error ? e.stack : undefined,
        );
        Sentry.captureException(
          e instanceof Error
            ? e
            : new Error(`beforeLoad auth() hatasi: ${String(e)}`),
        );
      });
      console.error("[_app beforeLoad] auth() FAILED:", e);
      return { user: null };
    }
  },
});

function RouteComponent() {
  return (
    <>
      <Header />
      <ActiveProgramBanner />
      <Outlet />
    </>
  );
}
